import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';

export interface SubscriptionPlan {
  plan_name: string;
  display_name: string;
  tagline: string;
  tier_rank: number;
  monthly_price_inr: number | null;
  annual_price_inr: number | null;
  annual_monthly_rate_inr: number | null;
  monthly_price_usd: number | null;
  annual_price_usd: number | null;
  annual_monthly_rate_usd: number | null;
  influencer_limit: number;
  campaign_limit: number;
  team_member_limit: number;
  deliverable_limit: number;
  profile_refresh_limit: number;
  allowed_billing_intervals: string[];
  features: string[];
  is_public: boolean;
}

export function useSubscriptionPlans() {
  return useQuery<SubscriptionPlan[]>({
    queryKey: ['subscription-plans'],
    queryFn: async () => {
      const { data, error } = await supabase
        .from('subscription_plans')
        .select('*')
        .eq('is_public', true)
        .order('tier_rank', { ascending: true });

      if (error) {
        console.error('Error fetching subscription plans:', error);
        throw error;
      }
      return (data || []) as SubscriptionPlan[];
    },
    staleTime: 1000 * 60 * 30, // 30 minutes
    refetchOnWindowFocus: false,
  });
}
